export const LOTTO_LOAD_SUCCESS = 'lotto/LOAD_SUCCESS';
export const LOTTO_CHANGE_SUCCESS = 'lotto/CHANGE_SUCCESS';
export const LOTTO_CREATE_SUCCESS = 'lotto/CREATE_SUCCESS';
export const LOTTO_EDIT_SUCCESS = 'lotto/EDIT_SUCCESS';
export const LOTTO_DELETE_SUCCESS = 'lotto/DELETE_SUCCESS';
export const SET_BUSY = 'lotto/SET_BUSY';
export const UNSET_BUSY = 'lotto/UNSET_BUSY';
